import aboutImg from "../assets/aboutr.png";
import headImg from "../assets/kepalambg.png";

export default function AboutUs() {
  return (
    <section className="text-gray-600 body-font scroll-animate">
      <div className="container flex flex-col px-5 py-24 mx-auto">
        <div className="mx-auto lg:w-4/6">
          <div className="h-64 overflow-hidden rounded-lg scroll-animate">
            <img
              alt="about"
              className="object-cover object-center w-full h-full"
              src={aboutImg}
            />
          </div>
          <div className="flex flex-col mt-10 sm:flex-row">
            <div className="text-center sm:w-1/3 sm:pr-8 sm:py-8 scroll-animate">
              <div className="inline-flex items-center justify-center w-20 h-20 text-gray-400 bg-gray-200 rounded-full">
                <img
                  src={headImg}
                  alt="Profile Icon"
                  className="rounded-full object-contain"
                />
              </div>
              <div className="flex flex-col items-center justify-center text-center">
                <h2 className="mt-4 text-lg font-medium text-gray-900 title-font">
                  Arizal Muhamad R.
                  <br />
                  Kepala Pengawas MBG Depok
                </h2>
                <div className="w-12 h-1 mt-2 mb-4 bg-indigo-500 rounded"></div>
                <p className="text-base">
                  Program MBG hadir untuk wujudkan generasi Depok yang
                  sehat, cerdas, dan berprestasi melalui gizi terbaik.
                  <br /> <strong>Depok Maju!</strong>
                </p>
              </div>
            </div>
            <div className="pt-4 mt-4 text-center border-t border-gray-200 sm:w-2/3 sm:pl-8 sm:py-8 sm:border-l sm:border-t-0 sm:mt-0 sm:text-left scroll-animate">
              <p className="mb-4 text-lg leading-relaxed">
                Gizimon MBG adalah portal resmi informasi Program Makanan Bergizi Gratis (MBG) Kota Depok 
                yang diselenggarakan oleh Dinas Ketahanan Pangan, Pertanian, dan Perikanan (DKP3).
                Program ini bertujuan menyediakan makanan bergizi, aman, sehat, utuh, dan halal (ASUH) 
                bagi siswa-siswi sekolah di seluruh Kota Depok. <br />
                Terdapat 12 tempat produksi yang memastikan pengolahan makanan dilakukan secara higienis 
                dan sesuai standar keamanan pangan. Melalui pengawasan ketat, pelatihan berkelanjutan, 
                dan sinergi bersama sekolah-sekolah penerima MBG, Kota Depok berkomitmen membangun 
                generasi yang sehat, cerdas, dan berdaya saing.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
